<app-loading *ngIf="contentReady"></app-loading>

<section
  class="bbm-page"
  [class.rtl]="isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="bbm-shell">

    <!-- HERO -->
    <section class="bbm-hero">

      <div class="bbm-hero-top">

        <div class="bbm-main-info">

          <div class="bbm-avatar">
            <i
              class="fa-solid fa-boxes-stacked"
              aria-hidden="true"
            ></i>
          </div>

          <div class="bbm-hero-copy">
            <span class="bbm-eyebrow">
              {{ "manage inventory" | transloco }}
            </span>

            <h2>
              {{ "products" | transloco }}
            </h2>

            <p>
              {{ "manage inventory" | transloco }}
            </p>
          </div>

        </div>

        <div
          class="bbm-hero-counter"
          *ngIf="!noData"
        >
          <strong>
            {{ stockTotal || allData.length }}
          </strong>

          <span>
            {{ "items" | transloco }}
          </span>
        </div>

      </div>

      <!-- MAIN ACTIONS -->
<div
  class="bbm-actions-scroll bbm-hero-actions noPrint"
  *ngIf="!isStockTaking"
>

        @if(isAdmin || isSubAdmin){
          <button
            type="button"
            routerLink="/AddItem"
            class="bbm-action-btn bbm-action-success"
          >
            <i
              class="fa-solid fa-plus"
              aria-hidden="true"
            ></i>

            <span>
              {{ "add stock" | transloco }}
            </span>
          </button>
        }
        @else {
          <button
            type="button"
            class="bbm-action-btn bbm-action-success"
            (click)="checkWarehouseType()"
          >
            <i
              class="fa-solid fa-cart-plus"
              aria-hidden="true"
            ></i>

            <span>
              {{ "add order" | transloco }}
            </span>
          </button>
        }

        @if(
          warehouseTypeService.isClinic() ||
          warehouseTypeService.isShopAndClinic()
        ){
          <button
            type="button"
            routerLink="/AllServices.mobile"
            class="bbm-action-btn bbm-action-primary"
          >
            <i
              class="fa-solid fa-stethoscope"
              aria-hidden="true"
            ></i>

            <span>
              {{ "all services" | transloco }}
            </span>
          </button>
        }

        @if(isAdmin && warehouseTypeService.isBlueBoxMain){
          <button
            type="button"
            routerLink="/bundles.mobile"
            class="bbm-action-btn bbm-action-primary"
          >
            <i
              class="fa-solid fa-boxes-stacked"
              aria-hidden="true"
            ></i>

            <span>
              {{ "bundles" | transloco }}
            </span>
          </button>

          <button
            type="button"
            routerLink="/brands.mobile"
            class="bbm-action-btn bbm-action-primary"
          >
            <i
              class="fa-solid fa-copyright"
              aria-hidden="true"
            ></i>

            <span>
              {{ "brands" | transloco }}
            </span>
          </button>
        }

        @if(!noData){
          <button
            type="button"
            class="bbm-action-btn bbm-action-warning"
            (click)="stockTaking()"
          >
            <i
              class="fa-solid fa-clipboard-check"
              aria-hidden="true"
            ></i>

            <span>
              {{ "stockTaking" | transloco }}
            </span>
          </button>
        }

        @if(!noData && !isSubAdmin){
          <button
            type="button"
            class="bbm-action-btn bbm-action-warning"
            (click)="
              resetPagination();
              getwarehouseBytopSale(1)
            "
          >
            <i
              class="fa-solid fa-arrow-trend-up"
              aria-hidden="true"
            ></i>

            <span>
              {{ "mostSales" | transloco }}
            </span>
          </button>
        }

        @if(warehouseTypeService.isCompany()){
          <button
            type="button"
            routerLink="/homegridview"
            class="bbm-action-btn bbm-action-primary"
          >
            <i
              class="fa-solid fa-table-list"
              aria-hidden="true"
            ></i>

            <span>
              {{ "list view" | transloco }}
            </span>
          </button>
        }

      </div>

      <!-- STOCK TAKING EXIT -->
      @if(isStockTaking){
        <div class="bbm-actions-grid bbm-hero-actions noPrint">

          <button
            type="button"
            class="
              bbm-action-btn
              bbm-action-warning
              bbm-action-wide
            "
            (click)="clearSearch()"
          >
            <i
              class="fa-solid fa-arrow-left"
              aria-hidden="true"
            ></i>

            <span>
              {{ "all data" | transloco }}
            </span>
          </button>

        </div>
      }

    </section>

    <!-- SEARCH -->
    <section class="bbm-form-ticket">

      <div class="bbm-search-row">

        <div class="bbm-search-control">
          <i
            class="fa-solid fa-magnifying-glass"
            aria-hidden="true"
          ></i>

          <input
            type="text"
            class="bbm-control"
            [(ngModel)]="searchKey"
            [placeholder]="'item name' | transloco"
            (keydown.enter)="onEnterPressed()"
          >
        </div>

        <button
          type="button"
          class="bbm-action-btn bbm-action-primary"
          (click)="search()"
        >
          <i
            class="fa-solid fa-magnifying-glass"
            aria-hidden="true"
          ></i>

          <span>
            {{ "Search" | transloco }}
          </span>
        </button>

      </div>

      <div
        class="bbm-actions-grid"
        *ngIf="searched"
      >
        <button
          type="button"
          class="
            bbm-action-btn
            bbm-action-danger
            bbm-action-wide
          "
          (click)="clearSearch()"
        >
          <i
            class="fa-solid fa-rotate-left"
            aria-hidden="true"
          ></i>

          <span>
            {{ "all data" | transloco }}
          </span>
        </button>
      </div>

    </section>

    <!-- NO DATA -->
    @if(noData && !contentReady){
      <div class="bbm-empty-state">
        <app-nodata></app-nodata>
      </div>
    }

    <!-- STOCK CARDS -->
    <section
      class="bbm-ticket-list"
      *ngIf="!noData"
    >

      <ng-container
        *ngFor="
          let element of allData;
          index as i
        "
      >

        <article
          class="bbm-ticket"
          [ngClass]="{
            'bbm-ticket-danger':
              toInt(element.quantity) === 0,

            'bbm-ticket-warning':
              (
                toInt(element.quantity) > 0 &&
                isLowStock(toInt(element.quantity)) &&
                (isAdmin || isSubAdmin)
              ) ||
              (
                isExpiringSoon(element.expiration_data) &&
                (isAdmin || isSubAdmin)
              ),

            'bbm-ticket-success':
              element.is_daily_offer
          }"
        >

          <!-- PRODUCT TOP -->
          <div class="bbm-ticket-top">

            <div class="bbm-main-info">

              <div
                class="bbm-avatar bbm-avatar-contain"
                *ngIf="element.image; else noImage"
              >
                <img
                  [src]="fixImage(element.image)"
                  [alt]="getDisplayName(element)"
                >
              </div>

              <ng-template #noImage>
                <div class="bbm-avatar">
                  <i
                    class="fa-solid fa-box-open"
                    aria-hidden="true"
                  ></i>
                </div>
              </ng-template>

              <div class="bbm-copy">

                <div class="bbm-badges-row">

                  <span
                    class="bbm-status-pill"
                    [class.bbm-status-danger]="
                      toInt(element.quantity) === 0
                    "
                    [class.bbm-status-success]="
                      toInt(element.quantity) > 0
                    "
                  >
                    <i
                      class="fa-solid"
                      [class.fa-circle-xmark]="
                        toInt(element.quantity) === 0
                      "
                      [class.fa-boxes-stacked]="
                        toInt(element.quantity) > 0
                      "
                      aria-hidden="true"
                    ></i>

                    @if(toInt(element.quantity) === 0){
                      {{ "out of stock" | transloco }}
                    }
                    @else {
                      {{ "quantity" | transloco }}:
                      {{ element.quantity }}
                    }
                  </span>

                  <span
                    *ngIf="element.is_daily_offer"
                    class="bbm-badge bbm-badge-warning"
                  >
                    <i
                      class="fa-solid fa-fire"
                      aria-hidden="true"
                    ></i>

                    {{ "Daily Offer" | transloco }}
                  </span>

                </div>

                <h3>
                  {{ getDisplayName(element) }}
                </h3>

                <p *ngIf="element.barcode">
                  <i
                    class="fa-solid fa-barcode"
                    aria-hidden="true"
                  ></i>

                  <span class="bbm-code-value">
                    #{{ element.barcode }}
                  </span>
                </p>

              </div>

            </div>

            <!-- PRODUCT DROPDOWN -->
            @if(isAdmin || isSubAdmin){
              <div class="dropdown bbm-ticket-menu">

                <button
                  type="button"
                  class="bbm-menu-btn dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i
                    class="fa-solid fa-ellipsis-vertical"
                    aria-hidden="true"
                  ></i>
                </button>

                <ul class="dropdown-menu dropdown-menu-end">

                  <li>
                    <button
                      type="button"
                      class="dropdown-item"
                      (click)="addToCart(element)"
                    >
                      <i
                        class="fa-solid fa-cart-shopping"
                        aria-hidden="true"
                      ></i>

                      <span>
                        {{ "add or remove from cart" | transloco }}
                      </span>
                    </button>
                  </li>

                  @if(isAdmin || isSubAdmin){

                    <li *ngIf="warehouseTypeService.isBlueBoxMain">
                      <button
                        type="button"
                        class="
                          dropdown-item
                          bbm-dropdown-warning
                        "
                        (click)="toggleOffer(element.id)"
                      >
                        <i
                          class="fa-solid fa-fire"
                          aria-hidden="true"
                        ></i>

                        <span>
                          {{
                            element.is_daily_offer
                              ? ('Remove Daily Offer' | transloco)
                              : ('Make Daily Offer' | transloco)
                          }}
                        </span>
                      </button>
                    </li>

                    <li>
                      <button
                        type="button"
                        class="dropdown-item"
                        (click)="clone(element)"
                      >
                        <i
                          class="fa-regular fa-copy"
                          aria-hidden="true"
                        ></i>

                        <span>
                          {{ "clone" | transloco }}
                        </span>
                      </button>
                    </li>

                    <li>
                      <button
                        type="button"
                        class="dropdown-item"
                        (click)="openAddImage(element.id)"
                      >
                        <i
                          class="fa-regular fa-image"
                          aria-hidden="true"
                        ></i>

                        <span>
                          {{ "AddImage" | transloco }}
                        </span>
                      </button>
                    </li>

                    @if(!isSubAdmin){

                      <li>
                        <button
                          type="button"
                          class="
                            dropdown-item
                            bbm-dropdown-warning
                          "
                          (click)="edit(element)"
                        >
                          <i
                            class="fa-regular fa-pen-to-square"
                            aria-hidden="true"
                          ></i>

                          <span>
                            {{ "Edit" | transloco }}
                          </span>
                        </button>
                      </li>

                      @if(isSuperAdmin){
                        <li>
                          <button
                            type="button"
                            class="dropdown-item"
                            (click)="changeQuantity(element.id)"
                          >
                            <i
                              class="fa-solid fa-plus-minus"
                              aria-hidden="true"
                            ></i>

                            <span>
                              {{ "change Quantity" | transloco }}
                            </span>
                          </button>
                        </li>
                      }

                      <li>
                        <hr class="dropdown-divider">
                      </li>

                      <li>
                        <button
                          type="button"
                          class="
                            dropdown-item
                            bbm-dropdown-danger
                          "
                          (click)="deleteitem(element.id)"
                        >
                          <i
                            class="fa-regular fa-trash-can"
                            aria-hidden="true"
                          ></i>

                          <span>
                            {{ "Delete" | transloco }}
                          </span>
                        </button>
                      </li>

                    }

                  }

                </ul>

              </div>
            }

          </div>

          <!-- PRODUCT INFORMATION -->
          <div class="bbm-details-grid">

            <!-- CATEGORY -->
            <div class="bbm-detail-chip">
              <i
                class="fa-solid fa-layer-group"
                aria-hidden="true"
              ></i>

              <span>
                {{ "category" | transloco }}
              </span>

              <strong>
                {{ getCategoryName(element.category_id) | transloco }}
              </strong>
            </div>

            <!-- PET -->
            <div class="bbm-detail-chip">
              <i
                class="fa-solid fa-paw"
                aria-hidden="true"
              ></i>

              <span>
                {{ "pet" | transloco }}
              </span>

              <strong>
                {{ getPetName(element.pet) | transloco }}
              </strong>
            </div>

            <!-- PET TYPE -->
            <div class="bbm-detail-chip">
              <i
                class="fa-solid fa-shield-cat"
                aria-hidden="true"
              ></i>

              <span>
                {{ "pet type" | transloco }}
              </span>

              <strong>
                {{ getPetTypeName(element.pet_type) | transloco }}
              </strong>
            </div>

            <!-- WEIGHT -->
            <div class="bbm-detail-chip">
              <i
                class="fa-solid fa-weight-hanging"
                aria-hidden="true"
              ></i>

              <span>
                {{ "weight" | transloco }}
              </span>

              <strong>
                {{ element.weight || '-' }}
              </strong>
            </div>

            <!-- EXPIRATION -->
            <div
              class="bbm-detail-chip bbm-detail-wide"
              [class.bbm-detail-warning]="
                isExpiringSoon(element.expiration_data) &&
                (isAdmin || isSubAdmin)
              "
            >
              <i
                class="fa-regular fa-calendar"
                aria-hidden="true"
              ></i>

              <span>
                {{ "expiration date" | transloco }}
              </span>

              <strong>
                {{ formatDate(element.expiration_data) }}
              </strong>
            </div>

            <!-- MOST SALES -->
            @if(mostSales){
              <div
                class="
                  bbm-detail-chip
                  bbm-detail-success
                  bbm-detail-wide
                "
              >
                <i
                  class="fa-solid fa-arrow-trend-up"
                  aria-hidden="true"
                ></i>

                <span>
                  {{ "mostSales" | transloco }}
                </span>

                <strong>
                  {{ element.order_count || 0 }}
                  {{ "times" | transloco }}
                </strong>
              </div>
            }

          </div>

          <!-- PRICES -->
          @if(!isStockTaking){
            <div
              class="bbm-totals-block"
              *ngIf="getVisiblePrices(element).length > 0"
            >
              <div
                class="bbm-total-row"
                *ngFor="let price of getVisiblePrices(element)"
              >
                <span>
                  {{ price.label | transloco }}
                </span>

                <strong class="bbm-money-value">
                  {{ price.value | number:'1.0-2' }}
                  {{ "egp" | transloco }}
                </strong>
              </div>
            </div>
          }

          <!-- BOTTOM ACTIONS -->
          @if(!isStockTaking){
            <div class="bbm-actions-grid bbm-ticket-section">

              <button
                type="button"
                class="bbm-action-btn"
                [class.bbm-action-primary]="!isInCart(element)"
                [class.bbm-action-success]="isInCart(element)"
                [class.bbm-action-wide]="!isSuperAdmin"
                [disabled]="toInt(element.quantity) === 0"
                (click)="addToCart(element)"
              >
                <i
                  class="fa-solid fa-cart-shopping"
                  aria-hidden="true"
                ></i>

                <span>
                  {{ "add or remove from cart" | transloco }}
                </span>
              </button>

              @if(isSuperAdmin){
                <button
                  type="button"
                  class="bbm-action-btn bbm-action-warning"
                  (click)="changeQuantity(element.id)"
                >
                  <i
                    class="fa-solid fa-plus-minus"
                    aria-hidden="true"
                  ></i>

                  <span>
                    {{ "quantity" | transloco }}
                  </span>
                </button>
              }

            </div>
          }

        </article>

      </ng-container>

      <!-- LOADING MORE -->
      <div
        *ngIf="isLoadingMore"
        class="bbm-loader"
      >
        <span
          class="bbm-loader-spinner"
          aria-hidden="true"
        ></span>

        <span>
          {{ "Loading..." | transloco }}
        </span>
      </div>

    </section>

  </div>
</section>

<!-- FLOATING CART -->
<button
  *ngIf="cartItemCount > 0"
  type="button"
  class="bbm-floating-action noPrint"
  (click)="cartPopUpOpen()"
>
  <span class="bbm-badge">
    {{ cartItemCount }}
  </span>

  <i
    class="fa-solid fa-cart-shopping"
    aria-hidden="true"
  ></i>

  <span>
    {{ "Cart" | transloco }}
  </span>
</button>

<!-- QUANTITY POPUP -->
<div
  *ngIf="showRejectPopUp"
  class="bbm-modal-backdrop noPrint"
  [class.rtl]="isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <section
    class="bbm-modal-card"
    role="dialog"
    aria-modal="true"
  >

    <div class="bbm-modal-handle"></div>

    <!-- MODAL HEADER -->
    <div class="bbm-form-head">

      <div class="bbm-main-info">

        <div class="bbm-avatar">
          <i
            class="fa-solid fa-plus-minus"
            aria-hidden="true"
          ></i>
        </div>

        <div>
          <span class="bbm-eyebrow">
            {{ "quantity" | transloco }}
          </span>

          <h3>
            {{ "change Quantity" | transloco }}
          </h3>
        </div>

      </div>

      <button
        type="button"
        class="
          bbm-action-btn
          bbm-action-danger
          bbm-icon-action
        "
        (click)="close()"
        [attr.aria-label]="'close' | transloco"
      >
        <i
          class="fa-solid fa-xmark"
          aria-hidden="true"
        ></i>
      </button>

    </div>

    <!-- QUANTITY FORM -->
    <div class="bbm-modal-list">

      <div class="bbm-field">
        <label for="quantity">
          {{ "quantity" | transloco }}
        </label>

        <input
          class="bbm-control"
          type="number"
          id="quantity"
          [(ngModel)]="quantity"
          min="0"
          step="1"
          [placeholder]="'quantity' | transloco"
        >
      </div>

    </div>

    <!-- MODAL ACTIONS -->
    <div class="bbm-form-actions">

      <button
        type="button"
        class="bbm-action-btn bbm-action-success"
        (click)="onSubmit()"
      >
        <i
          class="fa-solid fa-check"
          aria-hidden="true"
        ></i>

        <span>
          {{ "Submit" | transloco }}
        </span>
      </button>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger"
        (click)="close()"
      >
        <i
          class="fa-solid fa-xmark"
          aria-hidden="true"
        ></i>

        <span>
          {{ "close" | transloco }}
        </span>
      </button>

    </div>

  </section>
</div>

<!-- ADD IMAGE POPUP -->
<div
  *ngIf="addImage"
  class="bbm-modal-backdrop noPrint"
  [class.rtl]="isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <section
    class="bbm-modal-card"
    role="dialog"
    aria-modal="true"
  >

    <div class="bbm-modal-handle"></div>

    <!-- MODAL HEADER -->
    <div class="bbm-form-head">

      <div class="bbm-main-info">

        <div class="bbm-avatar">
          <i
            class="fa-regular fa-image"
            aria-hidden="true"
          ></i>
        </div>

        <div>
          <span class="bbm-eyebrow">
            {{ "image" | transloco }}
          </span>

          <h3>
            {{ "AddImage" | transloco }}
          </h3>
        </div>

      </div>

      <button
        type="button"
        class="
          bbm-action-btn
          bbm-action-danger
          bbm-icon-action
        "
        (click)="close()"
        [disabled]="isUploadingImage"
        [attr.aria-label]="'close' | transloco"
      >
        <i
          class="fa-solid fa-xmark"
          aria-hidden="true"
        ></i>
      </button>

    </div>

    <!-- IMAGE UPLOAD -->
    <div class="bbm-modal-list">

      <div class="bbm-field">
        <label>
          {{ "image" | transloco }}
        </label>

        <div
          class="bbm-upload-zone"
          role="button"
          tabindex="0"
          (click)="fileInput.click()"
          (keydown.enter)="fileInput.click()"
        >
          <input
            #fileInput
            type="file"
            hidden
            accept="image/*"
            (change)="onImageSelected($event)"
          >

          <!-- EMPTY UPLOAD STATE -->
          <div
            *ngIf="!imagePreview"
            class="bbm-upload-placeholder"
          >
            <span class="bbm-upload-icon">
              <i
                class="fa-regular fa-image"
                aria-hidden="true"
              ></i>
            </span>

            <strong>
              {{ "upload image" | transloco }}
            </strong>

            <small>
              {{ 'PNG / JPG' | transloco }}
            </small>
          </div>

          <!-- IMAGE PREVIEW -->
          <div
            *ngIf="imagePreview"
            class="bbm-image-preview"
          >
            <img
              [src]="imagePreview"
              [alt]="'image' | transloco"
            >

            <button
              type="button"
              class="
                bbm-action-btn
                bbm-action-primary
                bbm-action-compact
                bbm-image-change-btn
              "
              (click)="
                fileInput.click();
                $event.stopPropagation()
              "
              [disabled]="isUploadingImage"
            >
              <i
                class="fa-regular fa-image"
                aria-hidden="true"
              ></i>

              <span>
                {{ "change image" | transloco }}
              </span>
            </button>
          </div>

        </div>
      </div>

    </div>

    <!-- MODAL ACTIONS -->
    <div class="bbm-form-actions">

      <button
        type="button"
        class="bbm-action-btn bbm-action-success"
        (click)="submitImage()"
        [disabled]="
          !selectedImageFile ||
          isUploadingImage
        "
      >
        <span
          *ngIf="isUploadingImage"
          class="bbm-loader-spinner"
          aria-hidden="true"
        ></span>

        <i
          *ngIf="!isUploadingImage"
          class="fa-solid fa-check"
          aria-hidden="true"
        ></i>

        <span *ngIf="!isUploadingImage">
          {{ "Submit" | transloco }}
        </span>

        <span *ngIf="isUploadingImage">
          {{ "Uploading..." | transloco }}
        </span>
      </button>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger"
        (click)="close()"
        [disabled]="isUploadingImage"
      >
        <i
          class="fa-solid fa-xmark"
          aria-hidden="true"
        ></i>

        <span>
          {{ "close" | transloco }}
        </span>
      </button>

    </div>

  </section>
</div>

<!-- CART POPUP -->
<div
  *ngIf="cartPopUp"
  class="bbm-modal-backdrop noPrint"
  [class.rtl]="isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <section
    class="bbm-modal-card"
    role="dialog"
    aria-modal="true"
  >

    <div class="bbm-modal-handle"></div>

    <!-- MODAL HEADER -->
    <div class="bbm-form-head">

      <div class="bbm-main-info">

        <div class="bbm-avatar">
          <i
            class="fa-solid fa-cart-shopping"
            aria-hidden="true"
          ></i>
        </div>

        <div>
          <span class="bbm-eyebrow">
            {{ cartItemCount }}
            {{ "items" | transloco }}
          </span>

          <h3>
            {{ "Cart" | transloco }}
          </h3>
        </div>

      </div>

      <button
        type="button"
        class="
          bbm-action-btn
          bbm-action-danger
          bbm-icon-action
        "
        (click)="close()"
        [attr.aria-label]="'close' | transloco"
      >
        <i
          class="fa-solid fa-xmark"
          aria-hidden="true"
        ></i>
      </button>

    </div>

    <!-- CART ITEMS -->
    <div class="bbm-modal-list">

      <div class="bbm-products-list">

        <div
          *ngFor="let item of cartItems"
          class="bbm-product-row"
        >
          <div class="bbm-product-name">
            {{ isAr ? item.name_ar : item.name_en }}
          </div>

          <button
            type="button"
            class="
              bbm-action-btn
              bbm-action-danger
              bbm-icon-action
            "
            (click)="removeFromCart(item)"
          >
            <i
              class="fa-solid fa-trash"
              aria-hidden="true"
            ></i>
          </button>
        </div>

      </div>

    </div>

    <!-- CART ACTIONS -->
    <div class="bbm-actions-grid">

      <button
        type="button"
        class="bbm-action-btn bbm-action-success"
        (click)="quickOrder()"
      >
        <i
          class="fa-solid fa-cart-arrow-down"
          aria-hidden="true"
        ></i>

        <span>
          {{ "proceed to add order" | transloco }}
        </span>
      </button>

      <button
        type="button"
        class="bbm-action-btn bbm-action-primary"
        routerLink="/myclients.mobile"
      >
        <i
          class="fa-solid fa-users"
          aria-hidden="true"
        ></i>

        <span>
          {{ "myclients" | transloco }}
        </span>
      </button>

      <button
        type="button"
        class="
          bbm-action-btn
          bbm-action-danger
          bbm-action-wide
        "
        (click)="close()"
      >
        <i
          class="fa-solid fa-xmark"
          aria-hidden="true"
        ></i>

        <span>
          {{ "close" | transloco }}
        </span>
      </button>

    </div>

  </section>
</div>